import cjquery from 'jquery';
import React, { Component } from 'react';
import language from '../../../../../assets/languages/language';
import FD from '../../../../RestAPI/fetchData';
import App_data from '../../../../config/App_data';
import ViewQuestion from '../../../../../Components-2025/QuestionBank/ViewQuestion';
import { Tooltip } from 'reactstrap';
import { renderHTMLContent } from '../../../../../common/function';
import { messages } from '../../../../../common/messages';
/* eslint-disable*/
class Frm2Beginquiz extends Component {
  constructor(props) {
    super(props);
    this.state = {
      successAlert: false,
      token: '',
      idname: '',
      quiz_id: this.props.params.quiz_id,
      offset: this.props.params.offset ? parseInt(this.props.params.offset) : 0,
      all_question_id: '',
      question_length: '',
      timer_value: '',
      include_timer: '',
      user_time_value: '',
      first_question_id: '',
      display_question: '',
      save_text: `${language.LC().SAVE_QUESTION}`,
      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      bookmarkColor: '',
      flagCSS: 'fa fa-flag-o mark-action-btn',
      timerstopbtn: 'pause_btn icon-control-pause',
      count: 0,
      ValidToken: false,
      choice_a: 'answer_box',
      choice_b: 'answer_box',
      choice_c: 'answer_box',
      choice_d: 'answer_box',
      result_block: 'card hide_block',
      report_block: 'card hide_block',
      clicked: false,
      choice: '',
      result: '',
      text_color: 'card-header',
      records: '',
      savedQuestion: false,
      comment: 'card-block',
      flashcard: 'card-block',
      comment_data: '',
      flash_data: [],
      flash_form: 'col-md-12 display_block',
      comment_arrow: '',
      flash_card_arrow: '',
      flash_class: 'edit_right_padding',
      count: 0,
      count_end_message: '',
      timer_stop: false,
      timer_tag: `${language.LC().STOP}`,
      timer_display: 'card-block',
      rating: 0,
      rated: false,
      ratting_text: `${language.LC().RATE_THIS_QUESTION}`,
      validated: false,
      comment_update: 'hide_block',
      comment_save: 'btn btn-primary active pointer_class',
      comment_update_id: '',
      next_block: '',
      previ_block: '',
      already_answered_status: '',
      selectedmenufrm: 'frm',
      display_loader: 'show_block',
      level: '2',
      tooltips: [
        {
          placement: `${language.LC().COMMENT_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
        {
          placement: `${language.LC().FLASHCARD_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
      ],
    };
  }
  componentWillUnmount() {
    clearInterval(this.timer);
  }
  tick() {
    const { count, token, idname, quiz_id } = this.state;
    if (count > 0) {
      const newCount = count - 1;
      const insertTime = { token, idname, quiz_id, user_time_value: newCount };
      FD.callAPI(`${App_data.backend_api}/frm_quizes/insertTimer`, insertTime).then(() => {});
      this.setState({ count: newCount });
    } else {
      clearInterval(this.timer);
    }
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    const timerStopState = localStorage.getItem('timer_stop');
    if (timerStopState !== null) {
      this.setState({ timer_stop: JSON.parse(timerStopState) });
      if (JSON.parse(timerStopState)) {
        this.setState({ timerstopbtn: 'pause_btn icon-control-play' });
      } else {
        this.setState({ timerstopbtn: 'pause_btn icon-control-pause' });
        this.timer = setInterval(this.tick.bind(this), 1000);
      }
    }
    if (parseInt(this.state.offset) === 0) {
      this.setState({ previ_block: 'card hide_block' });
    }
    const storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    if (storage_session) {
      this.setState({
        idname: storage_session['idname'],
        token: storage_session['token'],
      });
    }
    const data = {
      idname: storage_session['idname'],
      token: storage_session['token'],
      quiz_id: this.state.quiz_id,
    };
    FD.callAPI(`${App_data.backend_api}/frm_quizes/getQuize`, data).then((resp) => {
      if (resp.success && resp.singlequiz) {
        const all_questions = JSON.parse(JSON.parse(JSON.stringify(resp.singlequiz))).all_questions;
        const question_id = all_questions[this.state.offset];
        const question_length = all_questions.length;

        const timer_value = resp.timer_value || 1800;
        const user_time_value = resp.user_time_value || timer_value;

        this.setState({
          timer_value: timer_value,
          count: user_time_value,
          all_question_id: all_questions,
          question_length: question_length,
          first_question_id: question_id,
        });

        if (this.state.offset === question_length - 1) {
          this.setState({ next_block: 'card hide_block' });
        }

        const questionData = {
          token: this.state.token,
          idname: this.state.idname,
          question_id: question_id,
          quiz_id: this.state.quiz_id,
        };

        FD.callAPI(`${App_data.backend_api}/frm_question_bank/getQuestionsbyid`, questionData).then(
          (resp) => {
            if (resp.success && resp.questionsbyid) {
              const currentQuestion = resp.questionsbyid;
              const selectedChoice = currentQuestion['frm_answer_quizzes.selected_choice'] || '';
              const rightAnswer = currentQuestion['frm_answer_quizzes.answer'] || '';
              const answerStatus = currentQuestion['frm_answer_quizzes.id'] || '';
              const correctChoice = currentQuestion.right_choice || '';
              let showAnswer = false;
              let selected = '';

              if (selectedChoice) {
                selected = selectedChoice;
                showAnswer = true;
              } else if (answerStatus) {
                if (rightAnswer === 1) {
                  selected = correctChoice;
                  showAnswer = true;
                } else if (!rightAnswer) {
                  const choices = Object.keys(currentQuestion).filter(
                    (key) => key.startsWith('choice') && key !== correctChoice,
                  );
                  selected = choices.length > 0 ? choices[0] : '';
                  showAnswer = true;
                }
              }

              const choiceKeys = ['choice_a', 'choice_b', 'choice_c', 'choice_d'];
              const updatedChoices = {};

              choiceKeys.forEach((key) => {
                updatedChoices[key] = selected === key ? 'answer_box clicked_box' : 'answer_box';
              });

              this.setState({
                display_question: currentQuestion,
                choice: selected,
                clicked: !!selected,
                result_block: showAnswer ? 'card show_block' : 'card hide_block',
                text_color:
                  selected === correctChoice
                    ? 'card-header text_success'
                    : 'card-header text_failure',
                result: selected === correctChoice ? messages.CORRECT : messages.INCORRECT,
                display_loader: 'hide_block',
                timer_stop: !!selected,
                ...updatedChoices,
              });

              clearInterval(this.timer);
              if (!selected) {
                this.timer = setInterval(this.tick.bind(this), 1000);
              }

              // Always check bookmark state for the current question
              this.checkBookmarkState(question_id);
            } else {
              this.setState({ display_question: null });
            }
          },
        );
      } else {
        this.setState({ display_question: null });
      }
    });

    clearInterval(this.timer);
    this.timer = setInterval(this.tick.bind(this), 1000);
  }

  getAnswer = (choice, e) => {
    const { clicked } = this.state;
    this.setState({ choice: choice[0] });
    this.setState({ clicked: false });
  };

  validateAnswer = () => {
    const {
      choice,
      display_question,
      validated,
      token,
      idname,
      quiz_id,
      all_question_id,
      offset,
      level,
    } = this.state;
    if (choice) {
      this.setState({ clicked: true });
      const isCorrect = choice === display_question.right_choice;
      this.setState({
        text_color: isCorrect ? 'card-header text_success' : 'card-header text_failure',
        result: isCorrect ? messages.CORRECT : messages.INCORRECT,
        result_block: 'card show_block',
      });
      this.setState({ timer_stop: true });
      clearInterval(this.timer);
      if (!validated) {
        const right_answer = isCorrect ? 1 : 0;
        const answerQuizData = {
          token,
          idname,
          quiz_id,
          question_id: all_question_id[offset],
          answer: right_answer,
          selectedChoice: choice,
        };
        FD.callAPI(`${App_data.backend_api}/frm_quizes/answerQuiz`, answerQuizData).then((resp) => {
          if (resp.success) {
            const saveStatsData = {
              token,
              idname,
              question_id: all_question_id[offset],
              right_answer,
              time_done: this.state.count,
              level,
            };
            FD.callAPI(`${App_data.backend_api}/frm_question_bank/saveStats`, saveStatsData).then(
              (resp) => {
                if (resp.success) {
                  this.setState({ validated: true });
                }
              },
            );
          }
        });
      }
    }
  };

  getNext = () => {
    const { offset, all_question_id, quiz_id, question_length, token, idname } = this.state;
    this.setState({
      display_loader: 'show_block',
      validated: false,
      clicked: false,
      choice: '',
      result_block: 'card hide_block',
      report_block: 'card hide_block',
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      bookmarkColor: '',
      save_text: `${language.LC().SAVE_QUESTION}`,
    });
    const nextIndex = offset + 1;
    this.setState({ offset: nextIndex });
    if (nextIndex === question_length - 1) {
      this.setState({ next_block: 'card hide_block' });
    }
    if (nextIndex !== 0) {
      this.setState({ previ_block: '' });
    }
    const data = { token, idname, question_id: all_question_id[nextIndex], quiz_id: quiz_id };
    FD.callAPI(`${App_data.backend_api}/frm_question_bank/getQuestionsbyid`, data).then((resp) => {
      if (resp.success) {
        const currentQuestion = resp.questionsbyid;
        const selectedChoice = currentQuestion['frm_answer_quizzes.selected_choice'] || '';
        const rightAnswer = currentQuestion['frm_answer_quizzes.answer'] || '';
        const answerStatus = currentQuestion['frm_answer_quizzes.id'] || '';
        const correctChoice = currentQuestion.right_choice || '';
        let showAnswer = false;
        let selected = '';
        if (selectedChoice) {
          selected = selectedChoice;
          showAnswer = true;
        } else if (answerStatus) {
          if (rightAnswer === 1) {
            selected = correctChoice;
            showAnswer = true;
          } else if (!rightAnswer) {
            const choices = Object.keys(currentQuestion).filter(
              (key) => key.startsWith('choice') && key !== correctChoice,
            );
            selected = choices.length > 0 ? choices[0] : '';
            showAnswer = true;
          }
        }
        const choiceKeys = ['choice_a', 'choice_b', 'choice_c', 'choice_d'];
        const updatedChoices = {};

        choiceKeys.forEach((choice) => {
          updatedChoices[choice] = selected === choice ? 'answer_box clicked_box' : 'answer_box';
        });

        this.setState({
          display_question: currentQuestion,
          choice: selected,
          clicked: !!selected,
          result_block: showAnswer ? 'card show_block' : 'card hide_block',
          text_color:
            selected === correctChoice ? 'card-header text_success' : 'card-header text_failure',
          result: selected === correctChoice ? messages.CORRECT : messages.INCORRECT,
          display_loader: 'hide_block',
          timer_stop: !!selected,
          ...updatedChoices,
        });
        clearInterval(this.timer);
        if (!selected) {
          this.timer = setInterval(this.tick.bind(this), 1000);
        }
        this.checkBookmarkState(all_question_id[nextIndex]);
      }
    });
  };

  getPrevious = () => {
    const { offset, all_question_id, question_length, token, idname, quiz_id } = this.state;
    this.setState({
      display_loader: 'show_block',
      validated: false,
      clicked: false,
      choice: '',
      result_block: 'card hide_block',
      report_block: 'card hide_block',
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      bookmarkColor: '',
      save_text: `${language.LC().SAVE_QUESTION}`,
    });
    const prevIndex = offset - 1;
    this.setState({ offset: prevIndex });
    if (prevIndex < question_length - 1) {
      this.setState({ next_block: '' });
    }
    if (prevIndex === 0) {
      this.setState({ previ_block: 'card hide_block' });
    } else {
      this.setState({ previ_block: '' });
    }
    const data = { token, idname, question_id: all_question_id[prevIndex], quiz_id: quiz_id };
    FD.callAPI(`${App_data.backend_api}/frm_question_bank/getQuestionsbyid`, data).then((resp) => {
      if (resp.success) {
        const currentQuestion = resp.questionsbyid;
        const selectedChoice = currentQuestion['frm_answer_quizzes.selected_choice'] || '';
        const rightAnswer = currentQuestion['frm_answer_quizzes.answer'] || '';
        const answerStatus = currentQuestion['frm_answer_quizzes.id'] || '';
        const correctChoice = currentQuestion.right_choice || '';
        let showAnswer = false;
        let selected = '';
        if (selectedChoice) {
          selected = selectedChoice;
          showAnswer = true;
        } else if (answerStatus) {
          if (rightAnswer === 1) {
            selected = correctChoice;
            showAnswer = true;
          } else if (!rightAnswer) {
            const choices = Object.keys(currentQuestion).filter(
              (key) => key.startsWith('choice') && key !== correctChoice,
            );
            selected = choices.length > 0 ? choices[0] : '';
            showAnswer = true;
          }
        }
        const choiceKeys = ['choice_a', 'choice_b', 'choice_c', 'choice_d'];
        const updatedChoices = {};

        choiceKeys.forEach((key) => {
          updatedChoices[key] = selected === key ? 'answer_box clicked_box' : 'answer_box';
        });

        this.setState({
          display_question: currentQuestion,
          choice: selected,
          clicked: !!selected,
          result_block: showAnswer ? 'card show_block' : 'card hide_block',
          text_color:
            selected === correctChoice ? 'card-header text_success' : 'card-header text_failure',
          result: selected === correctChoice ? messages.CORRECT : messages.INCORRECT,
          display_loader: 'hide_block',
          timer_stop: !!selected,
          ...updatedChoices,
        });
        clearInterval(this.timer);
        if (!selected) {
          this.timer = setInterval(this.tick.bind(this), 1000);
        }
        this.checkBookmarkState(all_question_id[prevIndex]);
      }
    });
  };

  saveQuestion = (item, e) => {
    const { bookmarkCSS, token, idname, quiz_id, level } = this.state;
    const isSaved = bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark';
    const apiEndpoint = isSaved
      ? '/frm_question_bank/unsaveQuestion'
      : '/frm_question_bank/saveQuestion';
    const data = { token, idname, question_id: item.id, quiz_id, level };
    FD.callAPI(`${App_data.backend_api}${apiEndpoint}`, data).then((resp) => {
      if (resp.success) {
        this.checkBookmarkState(item.id);
      }
    });
  };

  _reportQuestion = () => {
    const { token, idname, quiz_id, display_question } = this.state;
    const commentInput = document.getElementById('comment');
    const comment = commentInput ? commentInput.value : '';
    if (!comment || comment.trim().length < 2) {
      return;
    }
    const data = { token, idname, question_id: display_question.id, comment, quiz_id };
    FD.callAPI(`${App_data.backend_api}/frm_question_bank/reportQuestion`, data).then((resp) => {
      if (resp.success) {
        this.setState({ successAlert: true, report_block: 'card show_block' });
        if (commentInput) commentInput.value = '';
      } else {
        this.setState({ successAlert: false });
      }
    });
  };

  onClose = (e) => {
    this.setState({
      report_block: 'card hide_block',
      successAlert: false,
    });
  };

  _displayReportForm = () => {
    this.setState({ report_block: 'card show_block', successAlert: false });
  };

  _hideReportForm = (item, e) => {
    this.setState({ report_block: 'card hide_block' });
  };

  _getToggleComment = (item, e) => {
    cjquery(this.refs['comment_toggle_div']).slideToggle(1000);
  };

  _getToggleFlash = (item, e) => {
    cjquery(this.refs['flash_toggle_div']).slideToggle(1000);
  };

  _saveFlashCard = (item, e) => {
    if (document.getElementById('flash_card').value == '') {
      return;
    }
    var flash_card = document.getElementById('flash_card').value;
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.id,
      flash_card: flash_card,
      quiz_id: this.state.quiz_id,
      level: this.state.level,
    };
    FD.callAPI(`${App_data.backend_api}/frm_question_bank/saveFlashCard`, data).then((resp) => {
      if (resp.success) {
        this.setState({ ValidToken: true });
        document.getElementById('flash_card').value = '';
        var params = {
          token: this.state.token,
          idname: this.state.idname,
          question_id: item.id,
          quiz_id: this.state.quiz_id,
        };
        FD.callAPI(`${App_data.backend_api}/frm_question_bank/getFlashCards`, params).then(
          (response) => {
            if (response.success) {
              this.setState({ ValidToken: true });
              if (response.flash_cards.length > 0) {
                this.setState({ flash_form: 'col-md-12 hide_block' });
                var flash_cards = response.flash_cards.map((items) => (
                  <li key={items.id}>
                    <div className=''>
                      <ul className='icon_list'>
                        <li>
                          <a className='pointer_class' onClick={this._editFlash.bind(this, items)}>
                            <i className='fa fa-pencil' />
                          </a>
                        </li>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._deleteFlash.bind(this, items)}
                          >
                            <i className='fa fa-close' />
                          </a>
                        </li>
                      </ul>
                      <div className={this.state.flash_class}>
                        <h4 />
                        <p>{items.flash_card}</p>
                      </div>
                    </div>
                  </li>
                ));
              } else {
                this.setState({ flash_form: 'col-md-12 display_block' });
                var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
              }
              this.setState({ flash_data: flash_cards });
            } else {
              var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
              this.setState({ ValidToken: false });
              this.setState({ flash_data: flash_cards });
              this.setState({ flash_form: 'col-md-12 display_block' });
            }
            return response;
          },
        );
      } else {
        this.setState({ ValidToken: false });
      }
    });
  };

  _editFlash = (item, e) => {
    this.setState({ flash_form: 'col-md-12 display_block' });
    document.getElementById('flash_card').value = item.flash_card;
  };

  _deleteFlash = (item, e) => {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      flash_card: item,
    };
    FD.callAPI(`${App_data.backend_api}/frm_quizes/deleteFlashCard`, data).then((resp) => {
      if (resp.success) {
        this.setState({ ValidToken: true });
        this.setState({ flash_form: 'col-md-12 display_block' });
        document.getElementById('flash_card').value = '';
        var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
        this.setState({ flash_data: flash_cards });
      } else {
        this.setState({ ValidToken: false });
      }
    });
  };

  timerHandler = () => {
    const { timer_stop, clicked, choice } = this.state;
    if (clicked || choice) {
      return;
    }
    const newTimerStopState = !timer_stop;
    this.setState({
      timer_stop: newTimerStopState,
      timerstopbtn: newTimerStopState
        ? 'pause_btn icon-control-play'
        : 'pause_btn icon-control-pause',
    });
    localStorage.setItem('timer_stop', JSON.stringify(newTimerStopState));
    if (newTimerStopState) {
      clearInterval(this.timer);
    } else {
      this.timer = setInterval(this.tick.bind(this), 1000);
    }
  };

  _getSummary = () => {
    this.context.router.push({
      pathname: `/frm/2/beforestart/${this.state.quiz_id}/${this.state.selectedmenufrm}/abondon`,
      state: {
        token: this.state.token,
        idname: this.state.idname,
        quiz_id: this.state.quiz_id,
        status_send: 'abondon',
        selectedMenu: this.state.selectedmenufrm,
      },
    });
  };

  // Helper to check and set bookmark state for the current question
  checkBookmarkState = (question_id) => {
    const { token, quiz_id, idname } = this.state;
    const paramsFav = { token, quiz_id, question_id, idname };
    FD.callAPI(`${App_data.backend_api}/frm_question_bank/getFavQuestions`, paramsFav).then(
      (response) => {
        if (response.success) {
          this.setState({
            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
            bookmarkColor: 'rgb(54, 141, 84)',
            save_text: `${language.LC().Question_Saved}`,
          });
        } else {
          this.setState({
            bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
            bookmarkColor: '',
            save_text: `${language.LC().SAVE_QUESTION}`,
          });
        }
      },
    );
  };

  render() {
    let questions = this.state.display_question;
    const { clicked, choice } = this.state;

    let data = '';

    let count_temp_var = this.state.count;
    let display_time = '';
    if (count_temp_var < 60) {
      display_time = count_temp_var + 'sec';
    } else {
      var temp_min = Math.trunc(count_temp_var / 60);
      var temp_sec = Math.trunc(count_temp_var % 60);
      display_time = temp_min + 'min ' + temp_sec + 'sec';
    }

    if (questions) {
      data = (
        <div>
          <div className='card'>
            <div className='card-header'>
              <img
                src={App_data.frontend_url + '/img/question_bank/question_icon_blue.svg'}
                className='margin_right_20'
                width='30'
                alt=''
              />
              {language.LC().Q}
              {parseInt(this.state.offset) + 1}{' '}
              {renderHTMLContent(questions.name, 'span', '', { contentEditable: false })}
              <div className='float-right text-right'>
                <i
                  className={
                    'fa fa-angle-left ques_arrow pointer_class ' +
                    (this.state.offset === 0 ? 'card hide_block' : '')
                  }
                  onClick={this.getPrevious}
                />
                <i
                  className={
                    'fa fa-angle-right ques_arrow pointer_class ' +
                    (this.state.offset === this.state.question_length - 1 ? 'card hide_block' : '')
                  }
                  onClick={this.getNext}
                />
              </div>
            </div>
            <div className='card-block'>
              <div className='row'>
                <div className='col-sm-9'>
                  <ViewQuestion
                    {...questions}
                    {...this.props}
                    setAnswer={this.getAnswer}
                    showAnswer={clicked}
                    correctChoice={questions.right_choice}
                    selectedChoice={choice}
                  >
                    <div className='col-md-12 mt-2'>
                      <div className='row align-items-center'>
                        <button
                          type='button'
                          className='btn btn-primary pointer_class margin_bottom_10 margin_right_10'
                          onClick={this.validateAnswer}
                          disabled={this.state.clicked || !this.state.choice}
                        >
                          {language.LC().VALIDATE}
                        </button>
                        <span className='up tooltip-hover-questions' style={{ padding: '10px' }}>
                          <div className='tootip_box'> {this.state.save_text} </div>
                          <i
                            onClick={this.saveQuestion.bind(this, questions)}
                            className={this.state.bookmarkCSS}
                            style={{ color: this.state.bookmarkColor }}
                          >
                            {' '}
                          </i>
                        </span>
                        <span className='up tooltip-hover-questions vertical-align-middle'>
                          <div className='tootip_box'> {language.LC().REPORT_THIS_QUESTION} </div>
                          <div
                            className='report-icon-wrapper'
                            onClick={this._displayReportForm.bind(this, questions)}
                          >
                            <img src={App_data.frontend_url + '/img/report4.png'} alt='report' />
                          </div>
                        </span>
                      </div>
                    </div>
                  </ViewQuestion>
                </div>
                <div className='col-sm-3'>
                  <div className='timer_outer'>
                    <i className='fa fa-clock-o' />
                    <span className='timer_box'>{display_time}</span>
                  </div>
                  <span className={'quiz_timer_btn ' + this.state.timer_display}>
                    <button
                      type='button'
                      className={
                        this.state.timer_stop
                          ? 'pause_btn icon-control-play'
                          : 'pause_btn icon-control-pause'
                      }
                      onClick={this.timerHandler}
                    />
                  </span>
                  <p className='text-danger'>
                    {renderHTMLContent(this.state.count_end_message, 'div', '', {
                      contentEditable: false,
                    })}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className={this.state.result_block}>
            <div className={this.state.text_color}>{this.state.result}</div>
            <div className='card-block'>
              {renderHTMLContent(questions.answer, 'div', '', { contentEditable: false })}
            </div>
          </div>

          <div className={this.state.report_block}>
            <div className='card-header'>{language.LC().REPORT}</div>
            {!this.state.successAlert ? (
              <div className='card-block'>
                <div className='row'>
                  <div className='col-md-12'>
                    <label className='form-control-label' htmlFor='textarea-input'>
                      <strong>{language.LC().COMMENT}</strong>
                    </label>
                  </div>
                  <div className='col-md-12 margin_bottom_10'>
                    <textarea
                      id='comment'
                      name='comment'
                      rows='6'
                      className='form-control'
                      placeholder='Content..'
                    />
                  </div>
                </div>
                <div className='row'>
                  <div className='col-md-12'>
                    <button
                      type='button'
                      className='btn btn-primary active pointer_class'
                      onClick={this._reportQuestion.bind(this, questions)}
                    >
                      {language.LC().REPORT}
                    </button>
                    <button
                      type='button'
                      className='btn btn-danger active pointer_class margin_left_10'
                      onClick={this._hideReportForm.bind(this, questions)}
                    >
                      {language.LC().CANCEL}
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className='card-block'>
                <div className='row'>
                  <div className='col-sm-12 report-Success-card'>
                    <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                    <label className='form-control-label' htmlFor='textarea-input'>
                      <strong> {language.LC().REPORT_SEND_SUCCESS_MESSAGE}</strong>
                    </label>
                    <button
                      type='button'
                      className='btn btn-primary active pointer_class  min-vw-120'
                      onClick={this.onClose}
                    >
                      {' '}
                      {language.LC().CLOSE}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      );
    }

    return (
      <div>
        <div className='animated fadeIn'>
          <div className='row'>
            <div className='col-sm-8 margin_bottom_20'>
              <h1 className='section_head'>
                {language.LC().QUIZ_ID} : {this.state.quiz_id}
              </h1>
              <h6 className='text-danger'>{this.state.already_answered_status}</h6>
            </div>
            <div className='col-sm-4 margin_bottom_20 text-sm-right'>
              <button className='btn btn-primary pointer_class' onClick={this._getSummary}>
                {language.LC().BACK_TO_SUMMARY}
              </button>
            </div>
          </div>

          <div className='row'>
            <div className='col-md-12 margin_bottom_20'>{data}</div>
          </div>
        </div>
        <div className={'loader_box ' + this.state.display_loader}>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
          </div>
        </div>
      </div>
    );
  }
}
class TooltipItem extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      tooltipOpen: false,
    };
  }

  toggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen,
    });
  }

  render() {
    return (
      <span>
        <img
          src={App_data.frontend_url + '/img/dashboard/info_icon.svg'}
          id={'Tooltip-' + this.props.id}
          width='18'
          alt=''
          style={{ marginLeft: '4px' }}
        />
        <Tooltip
          placement={this.props.place_tip}
          isOpen={this.state.tooltipOpen}
          target={'Tooltip-' + this.props.id}
          toggle={this.toggle}
        >
          <p className='tooltip_text'>{this.props.content}</p>
        </Tooltip>
      </span>
    );
  }
}
export default Frm2Beginquiz;



// WEBPACK FOOTER //
// ./src/views/FRM/Frm1Quizzes/part-2/Frm2Beginquiz/Frm2Beginquiz.js